import  { useState } from 'react'
 

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'


import { postDeductions } from '../../../../MyApi/hr/deductions'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddDeduction from '../../../../Components/hr/deductions/deductionsStore/AddDeduction'


const DeductionsStore = () => {
const [name ,setName]= useState("")
const [sb_employe_id ,setSbEmployeId] =useState("")
const [amount , setAmount] =useState("")
const [amount_type , setAmount_type] =useState("")
const [hr_attendance_id ,setHrAttendanceId]= useState("")
const [date, setDate] = useState("")
const [issue_date ,setIssueDate] = useState("")
const [paid, setPaid] = useState(1);
const [paid_date ,setPaidDate] =useState("")

 const mutation = useMutation("postdeduction" , (postData)=>postDeductions(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setName("")
        setAmount("")
        setAmount_type("")
        setHrAttendanceId("")
        setIssueDate("")
        setPaidDate("")
        setDate("")

    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name,   
        amount_type,
        amount,
        date,
        issue_date,
        paid,
        paid_date,
        sb_employe_id
    
    })
 }
 const isDisabled= ()=>{
    return !(name && issue_date && amount_type && amount && date && sb_employe_id && (paid === 1 &&paid_date   ))
 }
  return ( 

    <div>
        <PageHeader title="Add Deductions" showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddDeduction name={name} setSbEmployeId={setSbEmployeId}  date={date} setDate={setDate} paid_date={paid_date}  amount={amount} issue_date={issue_date} amount_Type={amount_type}   setName={setName}  setAmount={setAmount} paid={paid} setIssueDate={setIssueDate} setAmount_type={setAmount_type} setPaidDate={setPaidDate} setPaid={setPaid}  hr_attendance_id={hr_attendance_id} setHrAttendanceId={setHrAttendanceId} />
    </div>
  )
}

export default DeductionsStore